import React, { useState } from "react";
import style from "./innovation.module.scss";
import { TexhnextLogosYellow, LeftArrow, RightArrow } from "assets";
import {
  InnovationDetails,
  DriveDetails,
  EthicsDetails,
  PassionDetails,
  IntelligenceDetails,
  GritDetails,
  InnerNavbarPage,
} from "components/GeneralComponents";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

const InnovationUI = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location);
  const id = location.state;

  const [slideIndex, setSlideIndex] = useState(id);
  const [view, setView] = useState(() => {
    if (id === null) {
      return 0;
    } else {
      return id.view;
    }
  });
  // setView(5);

  const nextSlide = () => {
    if (view === 5) {
      setView(0);
    } else if (view < 5) {
      setView(1 + view);
    }
  };

  const prevSlide = () => {
    if (view === 0) {
      setView(5);
    } else if (view > 0) {
      setView(view - 1);
    }
  };

  const innovation = () => setView(0);
  const ethics = () => setView(1);
  const passion = () => setView(2);
  const intelligence = () => setView(3);
  const grit = () => setView(4);
  const drive = () => setView(5);

  return (
    <>
      <InnerNavbarPage setView={setView} />
      <div className={style.innovation_container}>
        <AnimatePresence exitBeforeEnter>
          <div className={style.left}>
            <motion.div
              className={style.show_container}
              key={view ? view : "empty"}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              {view === 0 ? (
                <InnovationDetails />
              ) : view === 1 ? (
                <EthicsDetails />
              ) : view === 2 ? (
                <PassionDetails />
              ) : view === 3 ? (
                <IntelligenceDetails />
              ) : view === 4 ? (
                <GritDetails />
              ) : view === 5 ? (
                <DriveDetails />
              ) : null}
            </motion.div>
            <div className={style.slider_container}>
              <div className={style.inner}>
                <button onClick={prevSlide}>
                  <img src={LeftArrow} alt="Left arrow" />
                </button>
                <div className={style.activeCon}>
                  <div
                    onClick={() => {
                      setView(0);
                      setSlideIndex(0);
                    }}
                    className={view === 0 ? style.active : style.inactive}
                  ></div>
                  <div
                    onClick={() => {
                      setView(1);
                      setSlideIndex(1);
                    }}
                    className={view === 1 ? style.active : style.inactive}
                  ></div>
                  <div
                    onClick={() => {
                      setView(2);
                      setSlideIndex(2);
                    }}
                    className={view === 2 ? style.active : style.inactive}
                  ></div>
                  <div
                    onClick={() => {
                      setView(3);
                      setSlideIndex(3);
                    }}
                    className={view === 3 ? style.active : style.inactive}
                  ></div>
                  <div
                    onClick={() => {
                      setView(4);
                      setSlideIndex(4);
                    }}
                    className={view === 4 ? style.active : style.inactive}
                  ></div>
                  <div
                    onClick={() => {
                      setView(5);
                      setSlideIndex(5);
                    }}
                    className={view === 5 ? style.active : style.inactive}
                  ></div>
                </div>
                <button onClick={nextSlide}>
                  <img src={RightArrow} alt="Right arrow" />
                </button>
              </div>
            </div>
          </div>
        </AnimatePresence>

        <div className={style.hex_container}>
          <div className={style.container}>
            <div className={`${style.hexagonArea} ${style.first}`}>
              <div
                role="button"
                onClick={() => innovation()}
                className={view === 0 ? style.hexagonActive1 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Innovation</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Innovation</h3>
                </div>
              </div>
              <div
                role="button"
                onClick={ethics}
                className={view === 1 ? style.hexagonActive2 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Ethics</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Ethics</h3>
                </div>
              </div>
            </div>
            <div className={`${style.hexagonArea} ${style.second}`}>
              <div
                role="button"
                onClick={drive}
                className={view === 5 ? style.hexagonActive3 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Drive</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Drive</h3>
                </div>
              </div>
              <div role="button" className={style.hexagon}>
                <div className={`${style.inner} ${style.yellow}`}>
                  <img src={TexhnextLogosYellow} alt="Technext" />
                </div>
              </div>
              <div
                role="button"
                onClick={passion}
                className={view === 2 ? style.hexagonActive4 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Passion</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Passion</h3>
                </div>
              </div>
            </div>
            <div className={`${style.hexagonArea} ${style.third}`}>
              <div
                role="button"
                onClick={grit}
                className={view === 4 ? style.hexagonActive5 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Grit</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Grit</h3>
                </div>
              </div>
              <div
                role="button"
                onClick={intelligence}
                className={view === 3 ? style.hexagonActive6 : style.hexagon}
              >
                <div className={style.inner}>
                  <h3>Intelligence</h3>
                </div>
                <div className={style.overlay}>
                  <h3>Intelligence</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.slider_container_down}>
          <div className={style.inner}>
            <button onClick={prevSlide}>
              <img src={LeftArrow} alt="Left arrow" />
            </button>
            <div className={style.activeCon}>
              <div className={view === 0 ? style.active : style.inactive}></div>
              <div className={view === 1 ? style.active : style.inactive}></div>
              <div className={view === 2 ? style.active : style.inactive}></div>
              <div className={view === 3 ? style.active : style.inactive}></div>
              <div className={view === 4 ? style.active : style.inactive}></div>
              <div className={view === 5 ? style.active : style.inactive}></div>
            </div>
            <button onClick={nextSlide}>
              <img src={RightArrow} alt="Right arrow" />
            </button>
          </div>
        </div>
        <div className={style.contact}>
          <button
            onClick={() => {
              navigate("/contact");
            }}
          >
            CONTACT US
          </button>
        </div>
      </div>
    </>
  );
};

export { InnovationUI };
